import { render, staticRenderFns } from "./KatkiPaneliButton.vue?vue&type=template&id=713782e2&scoped=true"
import script from "./KatkiPaneliButton.vue?vue&type=script&lang=ts"
export * from "./KatkiPaneliButton.vue?vue&type=script&lang=ts"
import style0 from "./KatkiPaneliButton.vue?vue&type=style&index=0&id=713782e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713782e2",
  null
  
)

export default component.exports